import Vue from 'vue'
import { getElapsedTime } from 'util/time-utils'
import { truncateText } from 'util/text-utils'


export default Vue.extend({
  data() {
    return {
      commentText: '',
      commentTextOnExpand: '',
      isTruncated: false
    }
  },
  props: {
    comment: {
      type: Object,
      required: true
    },
    truncateLength: {
      type: Number,
      default: 200
    },
    truncateAllowance: {
      type: Number,
      default: 9
    }
  },
  computed: {
    datetime() {
      return (new Date(this.comment.dateCreatedMillis)).toISOString()
    },
    elapsedTime() {
      return getElapsedTime(this.comment.dateCreatedMillis)
    }
  },
  methods: {
    expandComment() {
      this.commentText = this.commentTextOnExpand
      this.isTruncated = false
      // Call to tileMixin notifying the layout container that this comment is expanding.
      if (this.isTile) {
        this.tileHeightChanged()
      }
    },
    setupText() {
      const text = this.comment.text.trim()
      const truncatedText = truncateText(text, this.truncateLength, this.truncateAllowance)
      if (truncatedText) {
        this.isTruncated = true
        this.commentText = truncatedText
        this.commentTextOnExpand = text
      } else {
        this.commentText = text
      }
    }
  },
  created() {
    this.setupText()
  }
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/comment/comment-mixin.ts